let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cf9Pv")).then(() => parcelRequire('6cKKb'));